import type { Participant, User } from '@/types'

export const people: Participant[] = [
  { id: 'p1', displayName: 'Varun Pandey', email: 'varun.pandey@pssgway.com', isOrganizer: true, isExternal: false, talkRatio: 0.34, avatarUrl: null },
  { id: 'p2', displayName: 'Kareena Shah', email: 'kareena.shah@pssgway.com', isOrganizer: false, isExternal: false, talkRatio: 0.27, avatarUrl: null },
  { id: 'p3', displayName: 'Khushi Verma', email: 'khushi.verma@pssgway.com', isOrganizer: false, isExternal: false, talkRatio: 0.18, avatarUrl: null },
  { id: 'p4', displayName: 'Shivam Rao', email: 'shivam.rao@pssgway.com', isOrganizer: false, isExternal: false, talkRatio: 0.12, avatarUrl: null },
  { id: 'p5', displayName: 'Neha Iyer', email: 'neha@northwind.example', isOrganizer: false, isExternal: true, talkRatio: 0.09, avatarUrl: null },
  { id: 'p6', displayName: 'Arjun Mehta', email: 'arjun@fmslabs.example', isOrganizer: false, isExternal: true, talkRatio: null, avatarUrl: null },
]

export const currentUser: User = {
  id: 'u1',
  name: 'Varun Pandey',
  email: 'varun.pandey@pssgway.com',
  role: 'owner',
  avatarUrl: null,
  lastActiveAt: new Date().toISOString(),
  status: 'active',
}

export const members: User[] = [
  currentUser,
  { id: 'u2', name: 'Kareena Shah', email: 'kareena.shah@pssgway.com', role: 'admin', avatarUrl: null, lastActiveAt: new Date(Date.now() - 36e5).toISOString(), status: 'active' },
  { id: 'u3', name: 'Khushi Verma', email: 'khushi.verma@pssgway.com', role: 'member', avatarUrl: null, lastActiveAt: new Date(Date.now() - 26e5).toISOString(), status: 'active' },
  { id: 'u4', name: 'Shivam Rao', email: 'shivam.rao@pssgway.com', role: 'member', avatarUrl: null, lastActiveAt: new Date(Date.now() - 864e5).toISOString(), status: 'active' },
  { id: 'u5', name: 'Priya Nair', email: 'priya.nair@pssgway.com', role: 'viewer', avatarUrl: null, lastActiveAt: null, status: 'invited' },
  { id: 'u6', name: 'Rohit Gupta', email: 'rohit.gupta@pssgway.com', role: 'member', avatarUrl: null, lastActiveAt: new Date(Date.now() - 12 * 864e5).toISOString(), status: 'suspended' },
]
